import { FC } from 'react'

import styled from 'styled-components'

import { SimpleLabel } from 'src/Components/SimpleLabel'

interface ChooseDurationButtonProps {
  selected?: boolean
  onClick?: () => void
  text?: string
  labelText?: string
}

const StyledChooseDurationButton = styled.button<{ $selected?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  position: relative;
  width: 100%;
  padding: 12px 10px;
  border-radius: 16px;
  cursor: pointer;
  font-family: 'Segoe UI';
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  border: 1px solid
    ${({ $selected, theme }) =>
      $selected ? theme.color.brandGreen : theme.color.lightGrey};
  background: ${({ theme }) => theme.color.white};
  color: ${({ $selected, theme }) =>
    $selected ? theme.color.brandGreen : theme.color.darkGrey};

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.color.hoverWhite};
    border-color: ${({ $selected, theme }) =>
      $selected ? theme.color.brandGreen : theme.color.lightGrey};
    color: ${({ $selected, theme }) =>
      $selected ? theme.color.brandGreen : theme.color.darkGrey};
  }

  &:focus-visible:not(:disabled) {
    outline: none;
    background: ${({ theme }) => theme.color.hoverWhite};
    border-color: ${({ $selected, theme }) =>
      $selected ? theme.color.pressedGreen : theme.color.brandGreen};
  }

  &:active:not(:disabled) {
    background: ${({ theme }) => theme.color.white};
    border-color: ${({ theme }) => theme.color.lightGrey};
    color: ${({ theme }) => theme.color.mediumGrey};
  }

  &:disabled {
    cursor: not-allowed;
    border-color: ${({ theme }) => theme.color.lightGrey};
    background: ${({ theme }) => theme.color.white};
    color: ${({ theme }) => theme.color.lightGrey};
  }
`

const StyledSimpleLabel = styled(SimpleLabel)`
  position: absolute;
  top: -14px;
`

export const ChooseDurationButton: FC<ChooseDurationButtonProps> = ({
  selected,
  labelText,
  onClick,
  text,
}) => (
  <StyledChooseDurationButton $selected={selected} onClick={onClick}>
    {labelText && (
      <StyledSimpleLabel color='green'>{labelText}</StyledSimpleLabel>
    )}
    {text}
  </StyledChooseDurationButton>
)
